import CHILE_OFFER_FLOW_STEP_IDS from '../../../../../constants/factoring/chile-offer-flow-step-ids';
import SelectBankAccountStep from '../../steps/SelectBankAccountStep';

export default function buildExternalCessionBankAccountConfiguration() {
  return {
    id: CHILE_OFFER_FLOW_STEP_IDS.EXTERNAL_CESSION_BANK_ACCOUNT,
    title: 'Selecciona tu cuenta bancaria',
    tooltipTitle: 'Selecciona la cuenta bancaria donde realizar el giro',
    component: SelectBankAccountStep,
    props: {
      isExternal: true,
    },
  };
}
